import { render, staticRenderFns } from "./SalesSettings.vue?vue&type=template&id=c2a9d4ac&scoped=true&"
import script from "./SalesSettings.vue?vue&type=script&lang=js&"
export * from "./SalesSettings.vue?vue&type=script&lang=js&"
import style0 from "./SalesSettings.vue?vue&type=style&index=0&id=c2a9d4ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a9d4ac",
  null
  
)

export default component.exports